<template>
  <el-carousel
    height="480px"
    arrow="never"
    class="banner"
    :indicator-position="currentBanner.length > 1 ? '' : 'none'"
  >
    <el-carousel-item
      v-for="(item, index) in currentBanner"
      :key="'banner' + index"
    >
      <el-image class="banner-box image" :src="item.image" :alt="item.title" fit="cover">
      </el-image>
      <el-image
        class="banner-box min-image"
        :src="item.minImage"
        :alt="item.title"
        fit="cover"
      >
      </el-image>
      <div class="banner-title left">
     
        <h2>{{ item.title }}</h2>
        <div class="desc">{{ item.desc }}</div>
      </div>
  
    </el-carousel-item>
  </el-carousel>
</template>

<script>


export default {
  name: 'CasesBanner',
  data() {
    return {
      pathUrl: '',
      currentBanner: [], // 当前页面banner
      bannerList: [
        {
          banner: [
            {
              image:
                'https://cdn.ideamake.cn/sw-pc/images/web3.0/v2/banner-case-01.png',
              minImage:
                'https://cdn.ideamake.cn/sw-pc/images/web3.0/v2/banner-case-min-01.png',
              title: '兑现数字价值  帮助客户成功',
              desc: '先进房企正在使用思为营销云，加速营销数字化升级',
          
            },
          ],
        },
      ],

    };
  },

  mounted() {
 
    this.getCurrentBanner();

  
  },
  methods: {
    getCurrentBanner() {
      this.currentBanner = this.bannerList[0].banner;
    },
  },
};
</script>

<style lang="scss" scoped>
.banner {
  ::v-deep .el-carousel--horizontal {
    overflow-x: none !important;
  }
}
.banner-box {
  width: 100vw;
  height: 480px;
  position: relative;
  background-size: 100% 480px;
  background-position: 50%;
  background-repeat: no-repeat;
}
.banner-title {
  width: 1200px;
  height: 100%;
  margin: 0 auto;
  padding-top: 200px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);

  h2 {
    font-size: 36px;
    font-weight: 500;
    color: #2d2e30;
    padding-bottom: 24px;
    text-align: left;
  }
  .desc {
    font-size: 16px;
    line-height: 28px;
    color: #5a5c60;
    width: 550px;
    text-align: left;
  }

}


.banner {
  .min-image {
    display: none;
  }
  ::v-deep .el-carousel__indicators--horizontal {
    width: 1180px;
    bottom: 20px;
    .el-carousel__indicator {
      &.is-active {
        .el-carousel__button {
          background: #3777f6;
        }
      }
    }
    left: 20%;
    display: none;
  }
  ::v-deep .el-carousel__button {
    display: block;
    opacity: 1;
    width: 36px;
    height: 3px;
    background: #fff;
    position: relative;
  }
}
@media screen and (min-width: 1920px) {
  .el-carousel__item {
    text-align: center;
    background: #deebff;
  }
  .banner {
    .image {
      width: 1920px !important;
    }

  }
}

// 移动端布局
@import '@/views/cases/min-cases';
</style>
